"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var RouterPrompt_1 = __importDefault(require("../../../../components/Modals/RouterPrompt"));
var BlToggle_1 = __importDefault(require("../../../../components/FormComponents/BlToggle"));
var Validation_1 = __importDefault(require("../../../../components/Validation"));
var BlCheckbox_1 = __importDefault(require("../../../../components/FormComponents/BlCheckbox"));
var DeveloperSectionContainer_1 = __importDefault(require("../SectionsContainer/DeveloperSectionContainer"));
var PersonalSectionContainer_1 = __importDefault(require("../SectionsContainer/PersonalSectionContainer"));
var FormActions_1 = __importDefault(require("../FormActions"));
var Routes_1 = require("../../../../constants/Routes");
var GeneralSettings_1 = require("../../../../constants/GeneralSettings");
var ErrorFocus_1 = __importDefault(require("../../../../components/Validation/ErrorFocus"));
var schemaSlice_1 = require("../../../../features/post/schemaSlice");
var globalSlice_1 = require("../../../../features/global/globalSlice");
var api_1 = require("@react-google-maps/api");
var GoogleGeocoding_1 = __importDefault(require("../../../../constants/GoogleGeocoding"));
var i18n_1 = __importDefault(require("../../../../i18n"));
var postSlice_1 = require("../../../../features/post/postSlice");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var PostForm = function (_a) {
    var formikProps = _a.formikProps, steps = _a.steps, post = _a.post, preview = _a.preview, publish = _a.publish, save = _a.save, reset = _a.reset, handleSubmitApartmentForm = _a.handleSubmitApartmentForm, isApartmentFormSubmitted = _a.isApartmentFormSubmitted, setCollapsedApartmentId = _a.setCollapsedApartmentId, collapsedApartmentId = _a.collapsedApartmentId, setIsApartmentFormSubmitted = _a.setIsApartmentFormSubmitted;
    var t = react_i18next_1.useTranslation('common').t;
    var common = react_redux_1.useSelector(schemaSlice_1.selectCommonFields);
    var dispatch = react_redux_1.useDispatch();
    var _b = formik_1.useFormikContext(), dirty = _b.dirty, isSubmitting = _b.isSubmitting;
    var isDeveloper = function () { return post.isDeveloper; };
    var isLoaded = api_1.useJsApiLoader({
        googleMapsApiKey: GoogleGeocoding_1.default.API_KEY,
        libraries: GoogleGeocoding_1.default.MAP_LIBS,
        language: i18n_1.default.language,
    }).isLoaded;
    var handleCancel = function () {
        dispatch(globalSlice_1.addToastMessage({
            text: t('POST_SCREEN.UNSAVED_MESSAGE_NOTIFICATION'),
            appearance: 'info',
        }));
    };
    var removeParentEntityMedia = function (id, mediaId) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.removeParentEntityMediaById(id, mediaId))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REMOVE_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var reorderMedia = function (id, from, to) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.reorderBuildingMedia(id, from, to))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REORDER_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        dirty && !isSubmitting && (react_1.default.createElement(RouterPrompt_1.default, { headerTitle: t('POST_SCREEN.PROMPT_MODAL.TITLE'), confirmButtonTitle: t('POST_SCREEN.PROMPT_MODAL.CLOSE'), cancelButtonTitle: t('POST_SCREEN.PROMPT_MODAL.CONFIRM'), handleCancel: handleCancel })),
        react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(BlToggle_1.default, { className: styles_module_scss_1.default.post_type_toggle, options: common.deal.options, value: formikProps.values.deal, name: "deal", onChange: function (_a) {
                        var text = _a.text;
                        formikProps.setFieldValue('deal', text);
                    } })),
            isDeveloper() ? (react_1.default.createElement(DeveloperSectionContainer_1.default, { steps: steps, formikProps: formikProps, post: post, isLoaded: isLoaded, removeParentEntityMedia: removeParentEntityMedia, reorderMedia: reorderMedia, handleSubmitApartmentForm: handleSubmitApartmentForm, isApartmentFormSubmitted: isApartmentFormSubmitted, setCollapsedApartmentId: setCollapsedApartmentId, collapsedApartmentId: collapsedApartmentId, setIsApartmentFormSubmitted: setIsApartmentFormSubmitted })) : (react_1.default.createElement(PersonalSectionContainer_1.default, { steps: steps, formikProps: formikProps, post: post, isLoaded: isLoaded, removeParentEntityMedia: removeParentEntityMedia, reorderMedia: reorderMedia })),
            react_1.default.createElement("div", { className: "step-item-" + (steps.length - 1) },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.agree_section },
                    react_1.default.createElement("label", { htmlFor: "" },
                        react_1.default.createElement(Validation_1.default, { name: "acceptTerms", formikProps: formikProps },
                            react_1.default.createElement(BlCheckbox_1.default, { type: "checkbox", name: "acceptTerms", label: t('POST_SCREEN.AGREE'), checked: formikProps.values.acceptTerms, onChange: formikProps.handleChange('acceptTerms'), className: styles_module_scss_1.default.accept_terms }),
                            react_1.default.createElement(react_router_dom_1.Link, { target: "_blank", to: Routes_1.Routes.TermsAndConditions.path }, t('POST_SCREEN.TERMS_OF_USAGE'))))),
                react_1.default.createElement(FormActions_1.default, { canPublish: !post || !post.publishedAt, canSave: formikProps.dirty, canPreview: dirty || post.status !== GeneralSettings_1.POST_STATUSES.DRAFT, onPreview: function () { return preview(formikProps); }, onPublish: function () { return publish(formikProps); }, onSave: function () { return save(formikProps); }, onReset: function () { return reset(); } })),
            react_1.default.createElement(ErrorFocus_1.default, null))));
};
exports.default = PostForm;
